<template>
  <transition name="slide">
    <slot></slot>
  </transition>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
$duration: 0.8s;

.slide-enter-active {
  transition-duration: $duration;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: $duration;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 1000px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
